import SafeLocalStorage from 'safe-localstorage';
import { boot } from 'quasar/wrappers';
import { checkForAuth } from '#src/router';

/**
 * Checks for auth profile before every navigation.
 */
export default boot(({ router }) => {
  router.beforeEach((to, _, next) => {
    void checkForAuth(to, next);
  });

  // Redirect to deep link after auth
  const loginRedirect = SafeLocalStorage.get('loginRedirect');
  if (loginRedirect !== null) {
    SafeLocalStorage.remove('loginRedirect');
    if (!loginRedirect.includes('/logged-out')) {
      location.href = loginRedirect;
    }
  }
});
